import { useEffect } from "react";
import { useTheme } from "@/hooks/useTheme";
import { Theme } from "@/providers/theme/ThemeContext";
import useSettingsStore from "@/stores/settings.store";

export const useThemeToggle = () => {
  const { setTheme, useQueryTheme } = useTheme();
  const { setDarkMode } = useSettingsStore();
  const fetchedTheme = useQueryTheme();
  const isDarkMode = fetchedTheme.data === "dark";

  useEffect(() => {
    if (fetchedTheme.isFetched && fetchedTheme.data) {
      setDarkMode(isDarkMode);
    }
  }, [fetchedTheme.isFetched, fetchedTheme.data, isDarkMode, setDarkMode]);

  const toggleTheme = () => {
    const newTheme: Theme = isDarkMode ? "light" : "dark";
    setTheme.mutate(newTheme);
  };

  return {
    isDarkMode,
    toggleTheme,
    isThemeReady: fetchedTheme.isFetched,
  };
};
